



























































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const slsp = new SupplierServiceProxy()
const crsp = new CodeRuleServiceProxy();

export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      codeList:[],
      codeId:false,
      codeRuleId:"",
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    }
  },
  created() {
   this.getList()
  }, 
  watch:{
    // "codeRuleId":{
    //   handler(val){
    //     if(val){
    //       // console.log(111,this.codeRuleId)
    //       this.codeId = true
    //     }
    //   }
    // },
    "visible":{
      handler(val){
        if(val === true){
          this.codeId = false
        }
      }
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    close(){
      this.form.resetFields()
      this.$emit('close')
    },
    save(){
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          Object.keys(values).forEach(key => {
            const str = values[key]
            if(str !== undefined){
              values[key] = str.replace(/\s+/g,"")
            }
          });
          slsp.createSupplier(values).then(res =>{
            this.form.resetFields()
            this.confirmLoading = false
            this.$message.success(this.$t('page_user_management_new_success'))
            this.$emit('rel')
          }).catch(() =>{
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      });
    },
    async getList() {
      let result = await crsp.list("SupplierObject")
      this.codeList = result.map(item =>({label:item.name,value:item.id}))      
    },
    handleSelectChange(val) {
       if(val){
         this.form.setFieldsValue({["code"]:""})
        //  console.log(11111,this.form.getFieldValue("code"))
         this.codeId = true
       }else{
         this.codeId = false
       }
    }
  }
})

